import Button from "react-bootstrap/Button";
import '../ButtonComponent/index.css'

interface CancelButtonComponentsProps {
    titel?: string;
    isDisabled?: boolean;
    type?: any;
    onClick?: any;
    icon?: any;
    colour?: string;
}

//buttons that we frequently used
const CancelButtonComponents: React.FC<CancelButtonComponentsProps> = ({ titel, isDisabled, type, onClick, icon, colour }) => {
    return (<>
        <Button className='cancelButtonColor m-2 px-2' disabled={isDisabled} type={type} onClick={onClick} color={`${colour}`}>
            <div className="button-container-styles">
                {icon} &nbsp;
                {titel}
            </div>
        </Button>
    </>)
}

export default CancelButtonComponents;